// ── BillingClaudePanel (Evo Brain — panel 5) ─────────────────────────────────
// Ya no renderiza UI propia — el shell genérico vive en AssistantDock (ver
// contexts/AssistantContext.tsx). Cubre AMBOS tipos de documento — entityType
// es 'estimate' o 'invoice' según lo que esté seleccionado, no un módulo fijo.

import { useTranslation } from 'react-i18next';
import { useAssistantModule, useRegisterAssistantActive } from '../../contexts/AssistantContext.js';
import { useEstimate, useInvoice } from '../../hooks/useBilling.js';

interface Props {
  docType: 'estimate' | 'invoice' | null;
  docId: number | null;
}

export function BillingClaudePanel({ docType, docId }: Props) {
  const { t } = useTranslation();

  const entityType = docType ?? 'estimate';
  const entityId = docId != null && docType != null ? String(docId) : null;

  const { data: estimate } = useEstimate(docType === 'estimate' ? (docId ?? undefined) : undefined);
  const { data: invoice } = useInvoice(docType === 'invoice' ? (docId ?? undefined) : undefined);
  const doc = docType === 'estimate' ? estimate : invoice;

  useAssistantModule(entityType, entityId, undefined);

  useRegisterAssistantActive(entityType, entityId, {
    title: t('billing.assistant.title'),
    placeholder: docId != null ? t('billing.assistant.placeholder') : t('billing.assistant.placeholderDisabled'),
    inputDisabled: docId == null,
    emptyHint: t('billing.assistant.empty'),
    entityLink: docType && docId != null
      ? { label: doc?.number ?? `#${docId}`, href: `/facturacion/${docType}/${docId}` }
      : null,
  });

  return null;
}
